import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/general",
)({
  loader: () => ({
    crumb: "alfred.settings.nav.communicationGeneral.label",
  }),
})
